export class CustomImageEvent {
    name: string;
    imageIndex: number;

    constructor(name, imageIndex) {
        this.name = name;
        this.imageIndex = imageIndex;
    }
}
